import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DetalleNotaVentaComponent } from './detalle-nota-venta/detalle-nota-venta.component';
import { CabeceraNotaVentaComponent } from './cabecera-nota-venta/cabecera-nota-venta.component';
export class EditarNotaVentaComponent {
    constructor(accesolocalstorage, toastrService, messageRendererService, clog, notaVentaService, parametroEmpresaService, unidadNegocioService) {
        this.accesolocalstorage = accesolocalstorage;
        this.toastrService = toastrService;
        this.messageRendererService = messageRendererService;
        this.clog = clog;
        this.notaVentaService = notaVentaService;
        this.parametroEmpresaService = parametroEmpresaService;
        this.unidadNegocioService = unidadNegocioService;
        this.onSuccess = new EventEmitter();
        this.mostrar = false;
        this.processing = false;
        // Outputs
        this.onSaveNotaVenta = new EventEmitter();
        this.headerData = null;
        this.currentProcess = null;
        this.DetalleData = null;
        this.permiteUnidadNegocio = false;
        this.optionsUnidadesDeNegocio = [];
        this.folio = 0;
        this.CloseNotaVentaEspUpdate = false;
        this.log = this.clog.log('MAIN');
    }
    ngOnInit() {
        this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
        // this.log('process.env.NODE_ENV', process.env.NODE_ENV, process.env.NODE_ENV.toLowerCase().startsWith('dev'))
        this.parametroUnidadNegocio();
        this.loadUnidadNegocio();
    }
    parametroUnidadNegocio() {
        this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
            if (mensajes && mensajes.length > 0) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            this.permiteUnidadNegocio = respuesta.valor_bool;
        });
    }
    loadUnidadNegocio() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const inputParams = {
                    entidad: {
                        empresa_rut: this.rutEmpresa,
                        tipo: 1
                    }
                };
                this.optionsUnidadesDeNegocio = [];
                this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
                    const { registros } = respuesta;
                    this.optionsUnidadesDeNegocio = registros.map(unidad_negocio => ({
                        value: unidad_negocio.codigo,
                        label: unidad_negocio.nombre
                    }));
                    resolve();
                });
            });
        });
    }
    handleHeaderDataChange(data) {
        this.detallesComponent.handleHeaderDataChange(data);
    }
    onAddProductoRequest(notaEsp) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const headerIsValid = this.cabeceraComponent.validate();
            if (!headerIsValid) {
                this.toastrService.warning('Complete datos de cabecera');
                return;
            }
            const detailIsValid = this.detallesComponent.validate();
            if (!detailIsValid) {
                this.toastrService.warning('Complete datos de detalle');
                return;
            }
            const producto = this.detallesComponent.createPayloadAddProducto();
            this.headerData = this.cabeceraComponent.getHeaderData();
            const payload = {
                cabecera: this.headerData,
                ProductDocument: [producto],
            };
            this.log('agregar', JSON.stringify(payload));
            if (this.currentProcess && this.currentProcess.proceso)
                payload.proceso = this.currentProcess.proceso;
            var currentProcess;
            payload.folio = notaEsp.current.folio;
            payload.proceso = notaEsp.current.proceso;
            // EN EL MODO EDIT DEBE AGREGAR PRODUCTOS AL MISMO PROCESO Y NOTA DE VENTA GENERADA;
            currentProcess = yield this.notaVentaService.AgregarProductoDeNotaEsp(payload).toPromise();
            currentProcess.folio = notaEsp.current.folio;
            this.log('currentProcess', currentProcess);
            if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
                currentProcess.mensajes.forEach(mensaje => {
                    this.toastrService.error(mensaje.texto);
                });
                return;
            }
            this.cabeceraComponent.disableContent();
            if (!notaEsp || notaEsp.suppressSuccessToast !== true) {
                this.toastrService.success('Producto agregado con éxito');
            }
            this.currentProcess = currentProcess;
            this.detallesComponent.fillProductos(currentProcess);
            // this.log('Se agregó', producto)
            this.bloquearUnidadNegocioCabecera(producto);
        });
    }
    bloquearUnidadNegocioCabecera(productoSeleccionado) {
        // this.log('bloquear unidad negocio', productoSeleccionado)
        this.cabeceraComponent.disableUnidadNegocio(productoSeleccionado ? productoSeleccionado.unidad_negocio_codigo : null);
    }
    onDeleteProductoRequest(nvEsp) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var currentProcess;
            const linea = nvEsp.producto.linea;
            if (nvEsp.current) {
                this.currentProcess = nvEsp.current;
            }
            //ELIMINAR PRODUCTO DEL MISMO PROCESO GENERADO:
            currentProcess = yield this.notaVentaService.EliminarProductoDelEdit(this.currentProcess.proceso, this.currentProcess.folio, this.currentProcess.cabecera.tipoDocumentoDTE, linea).toPromise();
            currentProcess.folio = nvEsp.current.folio;
            if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
                currentProcess.mensajes.forEach(mensaje => {
                    this.toastrService.error(mensaje.texto);
                });
                return;
            }
            this.currentProcess = nvEsp.current;
            this.toastrService.success('Producto eliminado con éxito');
            this.detallesComponent.fillProductos(currentProcess);
        });
    }
    //MOSTRRAR NOTA DE VENTA SELECCIONADA
    LoadAndShow(nv, show) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.CloseNotaVentaEspUpdate = true;
            this.mostrar = show;
            this.folio = nv.folio;
            this.currentProcess = nv;
            // Asegurarse de que las opciones de unidad de negocio estén cargadas antes de cargar la cabecera
            if (this.optionsUnidadesDeNegocio.length === 0) {
                yield this.loadUnidadNegocio();
            }
            this.cabeceraComponent.Load(nv);
            const result = yield this.resolveAfter2Seconds(nv);
        });
    }
    resolveAfter2Seconds(nv) {
        return new Promise(resolve => {
            setTimeout(() => {
                this.detallesComponent.Load(nv);
            }, 300);
        });
    }
    guardarNotaVenta() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //OBTENGO LOS DATOS DE CABECERA PARA PODER HACER USO DE ESTOS AL GUARDAR
            this.headerData = this.cabeceraComponent.getHeaderData();
            this.DetalleData = this.detallesComponent.getDetalleData();
            this.currentProcess.cabecera.ordenCompra = this.headerData.ordenCompra;
            this.currentProcess.ProductDocument = this.DetalleData.productDocument;
            this.processing = true;
            //*TODO limpiar variable productDocument ya que se puede pisar con ProductDocument;
            delete this.currentProcess.productDocument;
            this.currentProcess.DocumentTotal = this.DetalleData.documentTotal;
            // ACTUALIZAR NOTA DE VENTA
            this.notaVentaService.UpdateProceso(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, this.folio, this.currentProcess).subscribe((currentProcess) => {
                this.log(currentProcess);
                if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
                    currentProcess.mensajes.forEach(mensaje => {
                        this.toastrService.error(mensaje.texto);
                    });
                    this.processing = false;
                    return;
                }
                const { folio } = currentProcess.respuesta.cabecera;
                this.toastrService.success('Nota venta ' + folio + ' modificada exitosamente');
                this.ValidaGuardadoNotaVenta = true;
                this.onSaveNotaVenta.emit(this.ValidaGuardadoNotaVenta);
                this.clearContents();
                this.mostrar = false;
                this.onSuccess.emit();
            }, error => {
                this.toastrService.error('No se pudo realizar la operación');
                this.processing = false;
            });
        });
    }
    clearContents() {
        this.processing = false;
        this.currentProcess = null;
        this.cabeceraComponent.clearContent();
        this.detallesComponent.clearContent();
    }
    clearFromButton() {
        this.modalConfirm.show(() => { this.clearContents(); });
    }
    CloseNotaVenta() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ValidaGuardadoNotaVenta = true;
            //OBTENGO LOS DATOS DE CABECERA PARA PODER HACER USO DE ESTOS AL GUARDAR
            this.headerData = this.cabeceraComponent.getHeaderData();
            //OBTENER LOS DATOS DE DETALLE
            this.DetalleData = this.detallesComponent.getDetalleData();
            // ACTUALIZAR NOTA DE VENTA
            this.currentProcess.cabecera.ordenCompra = this.headerData.ordenCompra;
            this.currentProcess.ProductDocument = this.DetalleData.productDocument;
            //*TODO limpiar variable productDocument ya que se puede pisar con ProductDocument;
            delete this.currentProcess.productDocument;
            this.currentProcess.DocumentTotal = this.DetalleData.documentTotal;
            //SI ES EDIT ACTUALIZAR TABLA DE PRODUCTOS
            if (this.CloseNotaVentaEspUpdate == true) {
                this.notaVentaService.UpdateProceso(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, this.folio, this.currentProcess).subscribe((currentProcess) => {
                    this.log(currentProcess);
                    if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
                        currentProcess.mensajes.forEach(mensaje => {
                            this.toastrService.error(mensaje.texto);
                        });
                        return;
                    }
                    const { folio } = currentProcess.respuesta.cabecera;
                    // LIMPIAR VARIABLES
                    this.clearContents();
                    this.mostrar = false;
                    this.onSuccess.emit(this.ValidaGuardadoNotaVenta);
                }, error => {
                    // this.toastrService.error('No se pudo realizar la operación')
                });
            }
        });
    }
}
